// import React from 'react'
// import { RiShoppingBag4Line } from "react-icons/ri";
// import { TbClockCheck } from "react-icons/tb";
// import { TbClockX } from "react-icons/tb";
// import { LuUserPlus } from "react-icons/lu";

// const PurchaseReturn = () => {
//   return (
//  <div className="page-content">
//   {/* Start Container Fluid */}
//   <div className="container-fluid">
//     {/* ========== Page Title Start ========== */}
//     <div className="row">
//       <div className="col-12">
//         <div className="page-title-box">
//           <h4 className="mb-0 fw-semibold">Return List</h4>
//           <ol className="breadcrumb mb-0">
//             <li className="breadcrumb-item">
//               <a href="javascript: void(0);">Purchase</a>
//             </li>
//             <li className="breadcrumb-item active">Return List</li>
//           </ol>
//         </div>
//       </div>
//     </div>
//     {/* ========== Page Title End ========== */}
//     <div className="row">
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2 d-flex align-items-center gap-2">
//                   Return Order{" "}
//                   <span className="badge text-danger bg-danger-subtle fs-12">
//                     <i className="bx bx-down-arrow-alt" />
//                     6.9%
//                   </span>
//                 </h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">
//                   367 <span className="fs-14">Items</span>
//                 </p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                  <TbClockCheck 
//                     className="fs-32 text-primary avatar-title"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2 d-flex align-items-center gap-2">
//                   Pending Return Order
//                 </h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">
//                   201 <span className="fs-14">Items</span>
//                 </p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <TbClockX 
//                     className="fs-32 text-primary avatar-title"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2 d-flex align-items-center gap-2">
//                   Total Customer{" "}
//                   <span className="badge text-success bg-success-subtle fs-12">
//                     <i className="bx bx-up-arrow-alt" />
//                     8.9%
//                   </span>
//                 </h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">5,634</p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                <LuUserPlus 
//                     className="fs-32 text-primary avatar-title"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center justify-content-between">
//               <div>
//                 <h4 className="card-title mb-2 d-flex align-items-center gap-2">
//                   Return Order Received
//                   <span className="badge text-danger bg-danger-subtle fs-12">
//                     <i className="bx bx-down-arrow-alt" />
//                     9.1%
//                   </span>
//                 </h4>
//                 <p className="text-muted fw-medium fs-22 mb-0">
//                   864 <span className="fs-14">Items</span>
//                 </p>
//               </div>
//               <div>
//                 <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                   <RiShoppingBag4Line
//                     className="fs-32 text-primary avatar-title"
//                   />
                  
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div className="row">
//       <div className="col-xl-12">
//         <div className="card">
//           <div className="d-flex card-header justify-content-between align-items-center">
//             <div>
//               <h4 className="card-title">All Return Items</h4>
//             </div>
//             <div className="dropdown">
//               <a
//                 href="#"
//                 className="dropdown-toggle btn btn-sm btn-outline-light rounded"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//               >
//                 This Month
//               </a>
//               <div className="dropdown-menu dropdown-menu-end">
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Download
//                 </a>
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Export
//                 </a>
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Import
//                 </a>
//               </div>
//             </div>
//           </div>
//           <div className="card-body p-0">
//             <div className="table-responsive">
//               <table className="table align-middle mb-0 table-hover table-centered">
//                 <thead className="bg-light-subtle">
//                   <tr>
//                     <th style={{ width: 20 }}>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck1"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck1"
//                         />
//                       </div>
//                     </th>
//                     <th>ID</th>
//                     <th>Order By</th>
//                     <th>Items</th>
//                     <th>Return Date</th>
//                     <th>Total</th>
//                     <th>Return Status</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck2"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck2"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV2540
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-1.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Michael A. Miner
//                     </td>
//                     <td> T-shirt , Wallet</td>
//                     <td> 07 Jan, 2023</td>
//                     <td>$289.00</td>
//                     <td>
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck3"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck3"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV3924
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-3.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Theresa T. Brose
//                     </td>
//                     <td>Golden Dress , Sunglass</td>
//                     <td> 03 Dec, 2023</td>
//                     <td>$213.00</td>
//                     <td>
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck4"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck4"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV5032
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-7.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       James L. Erickson
//                     </td>
//                     <td> Shoes , Cargo Pent</td>
//                     <td> 28 Sep, 2023 </td>
//                     <td>$735.00</td>
//                     <td>
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck5"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck5"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV1695
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-5.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Lily W. Wilson
//                     </td>
//                     <td> Watch , T-shirt </td>
//                     <td>10 Aug, 2023</td>
//                     <td>$324.00</td>
//                     <td>
//                       <span className="badge bg-warning-subtle text-warning py-1 px-2">
//                         Pending
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck6"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck6"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV8473
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-6.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Sarah M. Brooks
//                     </td>
//                     <td> Hand Bag , Watch</td>
//                     <td> 22 May, 2023 </td>
//                     <td>$153.00</td>
//                     <td>
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck7"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck7"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV2150
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-7.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Joe K. Hall
//                     </td>
//                     <td>Headphone , Dress</td>
//                     <td>15 Mar, 2023</td>
//                     <td>$424.00</td>
//                     <td>
//                       <span className="badge bg-warning-subtle text-warning py-1 px-2">
//                         Pending
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck7"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck7"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV5636
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-1.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />
//                       Ralph Hueber
//                     </td>
//                     <td>Headphone</td>
//                     <td>19 Dec, 2023</td>
//                     <td>$521.00</td>
//                     <td>
//                       <span className="badge bg-warning-subtle text-warning py-1 px-2">
//                         Pending
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck7"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck7"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV2940
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-3.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />
//                       Sarah Drescher
//                     </td>
//                     <td>Cap , Sunglass , Hand Bag</td>
//                     <td>11 Jun, 2023</td>
//                     <td>$313.00</td>
//                     <td>
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check fs-16 ms-1">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck7"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck7"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV9027
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-7.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />
//                       Leonie Meister
//                     </td>
//                     <td>Headphone , T-shirt</td>
//                     <td>19 Mar, 2023 </td>
//                     <td>$219.00</td>
//                     <td>
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             {/* end table-responsive */}
//           </div>
//           <div className="card-footer border-top">
//             <nav aria-label="Page navigation example">
//               <ul className="pagination justify-content-end mb-0">
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     Previous
//                   </a>
//                 </li>
//                 <li className="page-item active">
//                   <a className="page-link" href="javascript:void(0);">
//                     1
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     2
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     3
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     Next
//                   </a>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
//   {/* End Container Fluid */}
//   {/* ========== Footer Start ========== */}
//   <footer className="footer">
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12 text-center">
//           © Venton. Crafted by{" "}
//           <iconify-icon
//             icon="iconamoon:heart-duotone"
//             className="fs-18 align-middle text-danger"
//           />{" "}
//           <a href="" className="fw-bold footer-text" target="_blank">
//             Techzaa
//           </a>
//         </div>
//       </div>
//     </div>
//   </footer>
//   {/* ========== Footer End ========== */}
// </div>

//   )
// }

// export default PurchaseReturn


import React, { useState, useEffect } from 'react';
import { RiExchangeDollarFill } from "react-icons/ri";
import { BsCartX } from "react-icons/bs";
import { GrCube } from "react-icons/gr";
import { MdOutlineTrain } from "react-icons/md";
import { LuClipboardX } from "react-icons/lu";
import { LuClock } from "react-icons/lu";
import { LuClipboardCheck } from "react-icons/lu";
import { RiInbox2Line } from "react-icons/ri";
import { Link } from 'react-router-dom';
import InvoiceDetailPopup from '../Invoice/InvoiceDetail.js';

const OrderCancleList = () => {
  const [orders, setOrders] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortedOrders, setSortedOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Date filter states
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateFilterType, setDateFilterType] = useState('all'); // 'all', 'today', 'week', 'month', 'custom'
  const [dateSortOrder, setDateSortOrder] = useState('desc'); // 'asc' or 'desc'

  // Invoice Modal States
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const [stats, setStats] = useState({
    totalCancelled: 0
  });

  useEffect(() => {
    fetchAllData();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [orders, startDate, endDate, dateFilterType, dateSortOrder]);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      
      // Fetch all data in parallel
      const [ordersResponse, sellersResponse, usersResponse] = await Promise.all([
        fetch('https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_cancellation'),
        fetch('https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_seller_registration'),
        fetch('https://cyberathon.com/multivendor/index.php/Api/Master_controller/user_list')
      ]);

      const ordersData = await ordersResponse.json();
      const sellersData = await sellersResponse.json();
      const usersData = await usersResponse.json();

      if (ordersData.status && ordersData.data) {
        setOrders(ordersData.data);
      } else {
        setError('No cancellation data found');
      }

      if (sellersData.status && sellersData.data) {
        setSellers(sellersData.data);
      }

      if (usersData.status && usersData.data) {
        setUsers(usersData.data);
      }

    } catch (err) {
      setError('Failed to fetch data');
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  const calculateStats = (ordersData) => {
    const stats = {
      totalCancelled: ordersData.length
    };
    setStats(stats);
  };

  const getBusinessName = (sellerId) => {
    const seller = sellers.find(s => s.seller_id === sellerId?.toString());
    return seller ? seller.business_name : 'N/A';
  };

  const getUserName = (userId) => {
    const user = users.find(u => u.user_id === userId?.toString());
    return user ? user.name : 'N/A';
  };

  const filterByDateRange = (ordersData) => {
    if (dateFilterType === 'all') {
      return ordersData;
    }

    const now = new Date();
    let start, end;

    switch (dateFilterType) {
      case 'today':
        start = new Date(now.setHours(0, 0, 0, 0));
        end = new Date(now.setHours(23, 59, 59, 999));
        break;
      
      case 'week':
        start = new Date(now.setDate(now.getDate() - 7));
        end = new Date();
        break;
      
      case 'month':
        start = new Date(now.setMonth(now.getMonth() - 1));
        end = new Date();
        break;
      
      case 'custom':
        if (!startDate || !endDate) return ordersData;
        start = new Date(startDate);
        end = new Date(endDate);
        end.setHours(23, 59, 59, 999);
        break;
      
      default:
        return ordersData;
    }

    return ordersData.filter(order => {
      const orderDate = new Date(order.created_at);
      return orderDate >= start && orderDate <= end;
    });
  };

  const applyFilters = () => {
    let filtered = [...orders];

    // Apply date filter
    filtered = filterByDateRange(filtered);

    // Apply date sorting
    filtered = sortByDate(filtered);

    setSortedOrders(filtered);
    calculateStats(filtered);
    setCurrentPage(1);
  };

  const sortByDate = (ordersData) => {
    return [...ordersData].sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      
      if (dateSortOrder === 'asc') {
        return dateA - dateB; // Oldest first
      } else {
        return dateB - dateA; // Newest first
      }
    });
  };

  const toggleDateSort = () => {
    setDateSortOrder(prev => prev === 'asc' ? 'desc' : 'asc');
  };

  const handleDateFilterChange = (type) => {
    setDateFilterType(type);
    if (type !== 'custom') {
      setStartDate('');
      setEndDate('');
    }
  };

  const handleCustomDateFilter = () => {
    if (startDate && endDate) {
      setDateFilterType('custom');
    }
  };

  const clearDateFilter = () => {
    setDateFilterType('all');
    setStartDate('');
    setEndDate('');
  };

  const getOrderStatusBadge = (status) => {
    const s = status?.toLowerCase();

    if (s === "cancel") {
      return "badge border border-danger text-danger";
    }
    return "badge border border-dark text-dark";
  };

  const getPaymentStatusBadge = (status) => {
    const statusLower = status?.toLowerCase();
    if (statusLower === 'paid' || statusLower === 'completed') {
      return 'badge bg-success text-light px-2 py-1 fs-13';
    } else if (statusLower === 'pending') {
      return 'badge bg-light text-dark px-2 py-1 fs-13';
    } else if (statusLower === 'refund') {
      return 'badge bg-light text-dark px-2 py-1 fs-13';
    }
    return 'badge bg-secondary text-light px-2 py-1 fs-13';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleShowInvoice = (orderId) => {
    setSelectedOrderId(orderId);
    setShowInvoiceModal(true);
  };

  const handleCloseInvoice = () => {
    setShowInvoiceModal(false);
    setSelectedOrderId(null);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentOrders = sortedOrders.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedOrders.length / itemsPerPage);

  const getPageNumbers = () => {
    const pages = [];
    let startPage = Math.max(1, currentPage - 1);
    let endPage = Math.min(totalPages, currentPage + 1);

    if (currentPage === 1) {
      endPage = Math.min(3, totalPages);
    }

    if (currentPage === totalPages) {
      startPage = Math.max(totalPages - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Orders List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Orders</a>
                </li>
                <li className="breadcrumb-item active">Orders List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Date Filter Section */}
        <div className="row mb-3">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label">Quick Date Filter</label>
                    <div className="btn-group w-100" role="group">
                      <button
                        type="button"
                        className={`btn btn-sm ${dateFilterType === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleDateFilterChange('all')}
                      >
                        All
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${dateFilterType === 'today' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleDateFilterChange('today')}
                      >
                        Today
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${dateFilterType === 'week' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleDateFilterChange('week')}
                      >
                        Last 7 Days
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${dateFilterType === 'month' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handleDateFilterChange('month')}
                      >
                        Last 30 Days
                      </button>
                    </div>
                  </div>
                  
                  <div className="col-md-2">
                    <label className="form-label">Sort by Date</label>
                    <button
                      className="btn btn-outline-secondary w-100"
                      onClick={toggleDateSort}
                    >
                      <i className={`fa-solid fa-arrow-${dateSortOrder === 'desc' ? 'down' : 'up'} me-2`}></i>
                      {dateSortOrder === 'desc' ? 'Newest First' : 'Oldest First'}
                    </button>
                  </div>
                  
                  <div className="col-md-2">
                    <label htmlFor="startDate" className="form-label">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="startDate"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  
                  <div className="col-md-2">
                    <label htmlFor="endDate" className="form-label">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="endDate"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  
                  <div className="col-md-3">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleCustomDateFilter}
                      disabled={!startDate || !endDate}
                    >
                      <i className="fa-solid fa-filter me-1"></i>
                      Apply Custom Range
                    </button>
                    {(dateFilterType !== 'all' || startDate || endDate) && (
                      <button
                        className="btn btn-outline-secondary"
                        onClick={clearDateFilter}
                      >
                        <i className="fa-solid fa-times me-1"></i>
                        Clear
                      </button>
                    )}
                  </div>
                </div>
                
                {dateFilterType !== 'all' && (
                  <div className="mt-2">
                    <small className="text-muted">
                      <i className="fa-solid fa-info-circle me-1"></i>
                      Showing orders from: <strong>
                        {dateFilterType === 'today' && 'Today'}
                        {dateFilterType === 'week' && 'Last 7 days'}
                        {dateFilterType === 'month' && 'Last 30 days'}
                        {dateFilterType === 'custom' && startDate && endDate && 
                          `${formatDate(startDate)} to ${formatDate(endDate)}`}
                      </strong>
                    </small>
                  </div>
                )}
              </div>
              
            </div>
            <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-2">Order Cancel</h4>
                    <p className="text-muted fw-medium fs-22 mb-0">{stats.totalCancelled}</p>
                  </div>
                  <div>
                    <div className="avatar-md bg-primary bg-opacity-10 rounded">
                      <BsCartX className="fs-32 text-primary avatar-title" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>

        {/* Orders Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <div>
                  <h4 className="card-title">All Cancellation List</h4>
                </div>
                <div className="dropdown">
                  <a href="#" className="dropdown-toggle btn btn-sm btn-outline-light rounded" data-bs-toggle="dropdown" aria-expanded="false">
                    This Month
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <a href="#!" className="dropdown-item">Download</a>
                    <a href="#!" className="dropdown-item">Export</a>
                    <a href="#!" className="dropdown-item">Import</a>
                  </div>
                </div>
              </div>

              <div className="card-body p-0">
                {loading ? (
                  <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : error ? (
                  <div className="alert alert-danger m-3" role="alert">
                    {error}
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle mb-0 table-hover table-centered">
                      <thead className="bg-light-subtle">
                        <tr>
                          <th>Cancel ID</th>
                          <th>Order ID</th>
                          <th>Created at</th>
                          <th>Customer</th>
                          <th>Seller</th>
                          <th>Reason</th>
                          <th>Comments</th>
                          <th>Payment Status</th>
                          <th>Payment Mode</th>
                          <th>Order Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentOrders.length > 0 ? (
                          currentOrders.map((order) => (
                            <tr key={order.cancel_id}>
                              <td>#{order.cancel_id}</td>
                              <td>#{order.order_id}</td>
                              <td>{formatDate(order.created_at)}</td>
                              <td>{getUserName(order.user_id)}</td>
                              <td>{getBusinessName(order.seller_id)}</td>
                              <td>{order.reason_for_cancellation}</td>
                              <td>{order.comments || 'N/A'}</td>
                              <td>
                                <span className={getPaymentStatusBadge(order.payment_status)}>
                                  {order.payment_status}
                                </span>
                              </td>
                              <td>{order.payment_mode}</td>
                              <td>
                                <span className={getOrderStatusBadge(order.order_status)}>
                                  {order.order_status}
                                </span>
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  <button
                                    onClick={() => handleShowInvoice(order.order_id)}
                                    className="btn btn-soft-success btn-sm"
                                    title="View Invoice"
                                  >
                                    <i className="fa-solid fa-file-invoice align-middle fs-18"></i>
                                  </button>
                                  <Link to={`/order-list-edit/${order.order_id}`} className="btn btn-soft-primary btn-sm">
                                    <i className="fa-solid fa-pencil align-middle fs-18"></i>
                                  </Link>
                                  <Link className="btn btn-soft-danger btn-sm">
                                    <i className="fa-solid fa-trash align-middle fs-18"></i>
                                  </Link>
                                  <Link
                                    to={`/order-detail-view/${order.order_id}`}
                                    className="btn btn-light btn-sm"
                                  >
                                    <i className="fa-solid fa-eye fs-18"></i>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center py-4">
                              No cancellations found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={handlePrev}>Previous</button>
                    </li>
                    {getPageNumbers().map((page) => (
                      <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page)}>{page}</button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={handleNext}>Next</button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Invoice Detail Popup */}
      <InvoiceDetailPopup
        show={showInvoiceModal}
        onClose={handleCloseInvoice}
        orderId={selectedOrderId}
      />

      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon icon="iconamoon:heart-duotone" className="fs-18 align-middle text-danger" />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">Techzaa</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OrderCancleList;